import { motion } from 'motion/react'
import { useMemo } from 'react'
import { useEditAccountEmailState } from '@/src/stores/user/actions'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'

export const VerifyAccountEmail = () => {
  const state = useEditAccountEmailState()

  const buttonText = useMemo(
    () => {
      /*  if (isPending) {
      return 'Saving...'
    }

    if (isSuccess) {
      return 'Successfully saved'
    } */

      return 'Open Gmail'
    },
    [
      /* isPending, isSuccess, isError */
    ],
  )

  return (
    <motion.form
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='flex flex-col items-center px-10 pb-10'
      method='POST'
    >
      <p className='text-secondary text-center mb-8'>
        To verify your new email address, enter the one-time login code sent to
        {state?.variables?.email ? ` ${state?.variables?.email}` : ''}.
      </p>

      <Input
        name='email'
        className='mb-4'
        dimension='medium'
        placeholder='OTP'
        maxLength={6}
        minLength={6}
        required
      />

      <Button type='submit' className='w-full' variant='primary'>
        {buttonText}
      </Button>
    </motion.form>
  )
}
